import { PropsWithChildren } from "react";

interface CollapseProps extends PropsWithChildren {
  in?: boolean;
}

const Collapse = ({ in: isIn, children }: CollapseProps) => {
  return isIn && <>{children}</>;
};

export { Collapse, type CollapseProps };
